module.exports = __webpack_public_path__ + "img/4.0a6347c7.gif";